import { render } from "./inspectStatisticsComponent.vue?vue&type=template&id=64fd8be3&scoped=true"
import script from "./inspectStatisticsComponent.vue?vue&type=script&lang=js"
export * from "./inspectStatisticsComponent.vue?vue&type=script&lang=js"

import "./inspectStatisticsComponent.vue?vue&type=style&index=0&id=64fd8be3&lang=scss&scoped=true"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64fd8be3"]])

export default __exports__